<template>
  <div>
    <a-card :bordered="false" class="header-solid h-full mb-50" :bodyStyle="{ paddingTop: '12px' }"
      style="background: transparent; box-shadow: none;">

      <template #title>
        <a-row>
          <a-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
            <h6 class="font-web f-18"><a @click="gotoMainType" class="mr-5">
                <a-icon type="arrow-left" /></a>&nbsp;แบบฟอร์มคำขออนุมัติ <span
                class="ml-5 text-danger font-weight-bold">ลาหยุด</span>
            </h6>
            <p class="form-sub-title font-web ml-20">&nbsp;&nbsp;Leave of Absence Request Form</p>
          </a-col>
        </a-row>
      </template>

      <a-row :gutter="24" type="flex" align="stretch">
        <!-- history -->
        <a-col :xs="24" :sm="24" :md="0" :lg="1" :xl="1"></a-col>
        <a-col :xs="24" :sm="24" :md="8" :lg="7" :xl="7" class="h-full">
          <historyRequest :dataRequest="dataHistory" textHead="Leave of Absence" :loadingList="loadingList"
            class="h-full" />
        </a-col>
        <!-- form -->
        <a-col :xs="24" :sm="24" :md="16" :lg="15" :xl="15">
          <div class="form-container">
            <a-form class="font-web" :layout="'horizontal'">
              <h6 class="mt-0 mb-10 font-web">
                ช่องทางที่สามารถติดต่อได้
                <span class="text-danger">*</span>
              </h6>
              <a-form-item>
                <a-textarea placeholder="" v-model="formLeave.address" :auto-size="{ minRows: 3, maxRows: 5 }" />
              </a-form-item>

              <a-row type="flex" justify="space-between" align="middle" class="mb-10">
                <a-col>
                  <h6 class="mt-0 mb-0 font-web">
                    โควต้าวันลาที่สามารถใช้งานได้ แต่ละประเภท ( โปรดเลือก ) <span class="text-danger">*</span>
                  </h6>
                  <p class="mb-0 text-muted font-web" style="font-size: 13px;">
                    {{ currentFiscalYearText }}
                  </p>
                </a-col>
                <a-col v-if="availableYears.length > 1">
                  <a-radio-group v-model="currentYear" @change="fetchQuotaByYear" size="small">
                    <a-radio-button v-for="y in availableYears" :key="y" :value="y">
                      {{ y + 543 }}
                    </a-radio-button>
                  </a-radio-group>
                </a-col>
              </a-row>

              <div class="quota-row-wrapper mb-20">
                <a-spin :spinning="loadingQuota" tip="กำลังโหลดข้อมูลการลา...">
                  <div class="quota-grid">
                    <div v-for="item in quotaItems" :key="item.key" class="quota-card-wrapper"
                      @click="!item.isFull && (formLeave.absence_type = item.key)">
                      <div class="quota-card-inner" :class="{
                        'quota-card-selected': formLeave.absence_type === item.key,
                        'quota-card-disabled': item.isFull
                      }">
                        <div v-if="item.key === 'casual_b'" class="urgent-label">-Urgent-</div>
                        <div class="quota-title-en">{{ item.titleEn }}</div>
                        <div class="quota-title-th">({{ item.titleTh }})</div>
                        <div class="quota-stats">
                          <span class="quota-used">{{ item.used }}</span>
                          <span class="quota-sep"> / </span>
                          <span class="quota-total">{{ item.total }}</span>
                        </div>
                        <div v-if="item.isFull" class="quota-full-badge">โควตาเต็ม</div>
                      </div>
                    </div>
                  </div>
                </a-spin>
              </div>

              <a-form-item>
                <a-alert message="รายละเอียด" type="info" class="mt-10 mb-10"
                  v-if="formLeave.absence_type && formLeave.absence_type !== 'long_term_medical'">
                  <div slot="description">
                    <hr>
                    <span v-if="formLeave.absence_type === 'casual_a'">
                      <p class="mt-0 mb-0 text-danger">การลากิจทั่วไป ต้องลาล่วงหน้าอย่างน้อย 3 วันทำการ</p>
                    </span>
                    <span v-if="formLeave.absence_type === 'vacation'" v-html="desc.items[0].content_1"></span>
                    <span v-if="formLeave.absence_type === 'sick'" v-html="desc.items[0].content_2"></span>
                    <span v-if="formLeave.absence_type === 'medical'" v-html="desc.items[0].content_3"></span>
                    <span v-if="formLeave.absence_type === 'extra'" v-html="desc.items[0].content_4"></span>
                    <span v-if="formLeave.absence_type === 'casual_a'" v-html="desc.items[0].content_5"></span>
                    <span v-if="formLeave.absence_type === 'casual_b'" v-html="desc.items[0].content_5"></span>
                    <span v-if="formLeave.absence_type === 'monkhood'" v-html="desc.items[0].content_6"></span>
                    <span v-if="formLeave.absence_type === 'maternity'" v-html="desc.items[0].content_7"></span>
                    <span v-if="formLeave.absence_type === 'other'" v-html="desc.items[0].content_8"></span>
                    <a v-if="['casual_a', 'casual_b'].includes(formLeave.absence_type)"
                      href="https://drive.google.com/file/d/11_6ZTvptLRcgXO21rGtUDDW05zK7ZTUI/view?usp=sharing"
                      target="_blank" rel="noopener noreferrer">
                      <p class="mt-20 mb-0">
                        >> ประกาศเพิ่มเติม <<</p>
                    </a>
                  </div>
                </a-alert>
                <!-- casual -->
                <div v-if="['casual_a', 'casual_b'].includes(formLeave.absence_type)">
                  <h6 class="mt-0 mb-0 font-web">
                    หลักฐานประกอบการพิจารณา การลากิจทั่วไป / การลากิจฉุกเฉิน:
                  </h6>
                  <a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload" :multiple="false"
                    v-model="formLeave.file_backup" accept="image/*;capture=camera">
                    <a-button> <a-icon type="upload" /> Select File </a-button>
                  </a-upload>
                </div>



                <!-- sick request upload -->
                <div v-if="formLeave.absence_type === 'medical'">
                  <h6 class="mt-0 mb-0 font-web">
                    Upload medical certificate documents:
                    <span class="text-danger">*</span>
                  </h6>
                  <a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload" :multiple="false"
                    v-model="formLeave.file_backup" accept="image/*;capture=camera">
                    <a-button> <a-icon type="upload" /> Select File </a-button>
                  </a-upload>
                </div>

                <div v-if="['other'].includes(formLeave.absence_type)">
                  <a-textarea placeholder="" v-model="formLeave.remark" :auto-size="{ minRows: 3, maxRows: 5 }" />
                </div>
              </a-form-item>


              <!-- Date -->

              <a-descriptions bordered title="" size="small" :column="{ xxl: 3, xl: 3, lg: 3, md: 2, sm: 1, xs: 1 }">
                <a-descriptions-item>
                  <div slot="label">
                    <h6 class="mt-0 mb-0 font-web">
                      ขอลาวันที่ <span class="text-danger">*</span>
                    </h6>
                  </div>
                  <div v-if="formLeave.absence_type">
                    <a-date-picker class="w-full" :mode="['date']" :disabled-date="disabledStartDate"
                      v-model="formLeave.start_date" format="YYYY-MM-DD" placeholder=""
                      @openChange="handleStartOpenChange" />
                  </div>
                  <div v-else>
                    <p class="font-web text-danger mt-0 mb-0">โปรดเลือกประเภทการลาหยุด</p>
                  </div>
                </a-descriptions-item>
                <a-descriptions-item :span="2">
                  <div slot="label">
                    <h6 class="mt-0 mb-0 font-web">
                      ลาถึงวันที่ <span class="text-danger">*</span>
                    </h6>
                  </div>
                  <div v-if="formLeave.absence_type">
                    <a-date-picker class="w-full" :mode="['date']" :disabled-date="disabledEndDate"
                      :disabled="!formLeave.start_date" v-model="formLeave.end_date" format="YYYY-MM-DD" placeholder=""
                      :open="endOpen" @openChange="handleEndOpenChange" />
                  </div>
                  <div v-else>
                    <p class="font-web text-danger mt-0 mb-0">โปรดเลือกประเภทการลาหยุด</p>
                  </div>
                </a-descriptions-item>
                <a-descriptions-item>
                  <div slot="label">
                    <h6 class="mt-0 mb-0 font-web">
                      รวมลาทั้งสิ้น <span class="text-danger">*</span>
                    </h6>
                  </div>
                  <a-input-number type="number" v-model="formLeave.absence_amount" :disabled="formLeave.start_date === '' || formLeave.end_date === ''
                    " />
                </a-descriptions-item>

                <a-descriptions-item v-if="formLeave.absence_amount !== null &&
                  formLeave.absence_amount.toString().split('.').length &&
                  formLeave.absence_amount.toString().split('.')[1] === '5'
                " label="Note" :span="2">
                  <a-radio-group v-model="remarktext">
                    <a-radio value="a.m."> a.m. </a-radio>
                    <a-radio value="p.m."> p.m. </a-radio>
                  </a-radio-group>
                </a-descriptions-item>
              </a-descriptions>

              <h6 class="mt-20 mb-10 font-web">
                รายละเอียดการขอลา
                <span v-if="formLeave.absence_type !== 'vacation'" class="text-danger">*</span>
              </h6>
              <a-form-item>
                <a-textarea placeholder="" v-model="formLeave.detail" :auto-size="{ minRows: 3, maxRows: 5 }" />
              </a-form-item>

              <div class="mt-20 mb-20" v-if="this.$store.state.role.RulesUser.permissions.indexOf(
                `IC-HRI:chief`
              ) >= 0
              ">
                <h6 class="mt-0 mb-0 font-web">
                  Upload documents ( For chief to hr ):
                  <span class="text-danger">*</span>
                </h6>
                <a-upload :file-list="fileListCheif" :remove="handleCheifRemove" :before-upload="beforeCheifUpload"
                  :multiple="false" v-model="formLeave.fileCheif_backup" accept="image/*;capture=camera">
                  <a-button class="mt-10">
                    <a-icon type="upload" /> Select File
                  </a-button>
                </a-upload>
              </div>

              <a-form-item class="mt-20 mb-10">
                <a-row :gutter="24">
                  <a-col class="mb-10" :xs="8" :sm="8" :md="12">
                    <a-button type="danger" @click="clearForm">
                      <b>ยกเลิกการขอ</b>
                    </a-button>
                  </a-col>
                  <a-col :style="{ textAlign: 'right' }" class="mb-10" :xs="12" :sm="12" :md="12">
                    <div v-if="formLeave.absence_amount && formLeave.absence_amount >= 0.5">
                      <a-button type="primary" class="font-web submit-btn" :disabled="isFormLeave"
                        @click="dialogConfirm = true">
                        ส่งคำขออนุมัติ
                      </a-button>
                    </div>
                    <div v-else>
                      <a-button type="primary" class="font-web submit-btn" :disabled="true">
                        ส่งคำขออนุมัติ
                      </a-button>
                    </div>
                  </a-col>
                </a-row>
              </a-form-item>
            </a-form>
          </div>
        </a-col>
      </a-row>

    </a-card>
    <!-- dialog -->
    <a-modal title="Confirm" :visible="dialogConfirm" @ok="submitRequestLeave" @cancel="clearForm">
      <p class="mt-10 mb-10" v-if="boxLeaveError.length === 0">
        Are you sure to Submit ?
      </p>
      <a-spin v-if="loading" tip="Loading..."></a-spin>

      <div v-if="boxLeaveError.length !== 0">
        <a-alert :message="`Error The date you selected cannot be redeemed`" type="error" class="font-web" show-icon>
          <div slot="description">
            <span v-if="boxLeaveError[0].msg === undefined">
              {{ boxLeaveError[0] }}
            </span>
            <span v-else>{{ boxLeaveError[0].msg }}</span>
          </div>
        </a-alert>
      </div>
    </a-modal>
  </div>
</template>

<script>

const form = {
  start_date: "",
  end_date: "",
  absence_amount: null,
  detail: "",
  address: "",
  remark: "",
  absence_type: "",
  file_backup: null,
  fileCheif_backup: null,
};
import historyRequest from './history_request.vue';
import desc from '../../leaveofabsence/desc.js';
import { hriRequestMixin } from "@/mixins/hriRequestMixin";

export default {
  mixins: [hriRequestMixin],
  components: {
    historyRequest
  },
  data() {
    return {
      desc,
      dialogConfirm: false,
      // form
      formLeave: { ...form },
      loading: false,
      endOpen: false,
      radioStyle: {
        display: "block",
        fontWeight: "900",
        borderRaduis: '0px'
      },
      mode1: "time",
      // file upload
      fileList: [],
      fileListCheif: [],
      uploading: false,
      errorFile: "",
      // holidayList
      remarktext: "",
      holidayList: [],
      // error msg
      boxLeaveError: [],
      // config
      dataDayNotLeave: [],
      // history
      dataHistory: [],
      loadingList: false,
      stYear: [],
      stMonthBud: [],
      // condition date block
      blockForCasA: false,
      blockForCasB: false,
      // leave quota data
      leaveSummary: { vacation: 0, sick: 0, medical: 0, extra: 0, casual: 0 },
      vacationQuota: 0,
      casualQuota: 0,
      currentYear: null,
      availableYears: [],
      loadingQuota: false,
    };
  },
  computed: {
    currentFiscalYear() {
      const today = this.moment();
      const month = today.month() + 1;
      const year = today.year();
      return month >= 10 ? year + 1 : year;
    },
    currentFiscalYearText() {
      const fiscalYear = this.currentFiscalYear;
      const startYear = fiscalYear - 1;
      const endYear = fiscalYear;

      return `(ปีงบประมาณปัจจุบัน ${fiscalYear + 543} : 1 ตุลาคม ${startYear + 543} - 30 กันยายน ${endYear + 543})`;
    },
    dateVal() {
      const { start_date, end_date } = this.formLeave;
      return {
        start_date,
        end_date,
      };
    },
    isCasualLeave() {
      return ['casual_a', 'casual_b'].includes(this.formLeave.absence_type);
    },
    hasMissingFile() {
      return !this.formLeave.file_backup;
    },
    hasBasicFields() {
      return !!(
        this.formLeave.start_date &&
        this.formLeave.end_date &&
        this.formLeave.absence_amount !== null &&
        this.formLeave.address &&
        this.formLeave.absence_type
      );
    },
    isFormLeave() {
      if (!this.hasBasicFields) return true;

      if (this.isCasualLeave) {
        return this.hasMissingFile;
      }

      if (this.formLeave.absence_type === "vacation") {
        return false;
      }

      return this.formLeave.detail === "";
    },
    quotaItems() {
      const items = [
        { key: 'sick', titleEn: 'Sick Leave', titleTh: 'ลาป่วย', used: this.leaveSummary.sick || 0, total: 60 },
        { key: 'medical', titleEn: 'Medical Leave', titleTh: 'ลาป่วยแบบมีใบรับรองแพทย์', used: this.leaveSummary.medical || 0, total: 120 },
        { key: 'long_term_medical', titleEn: 'Long Term Medical', titleTh: 'ลาป่วยระยะยาว', used: '-', total: '-' },
        { key: 'casual_a', titleEn: 'Casual Leave', titleTh: 'ลากิจ แบบทั่วไป', used: this.leaveSummary.casual || 0, total: this.casualQuota || 0 },
        { key: 'casual_b', titleEn: 'Casual Leave', titleTh: 'ลากิจ แบบฉุกเฉิน', used: this.leaveSummary.casual || 0, total: this.casualQuota || 0 },
        { key: 'vacation', titleEn: 'Vacation Leave', titleTh: 'ลาพักร้อน', used: this.leaveSummary.vacation || 0, total: this.vacationQuota || 0 },
        { key: 'maternity', titleEn: 'Maternity Leave', titleTh: 'ลาคลอดบุตร', used: '-', total: '-' },
        { key: 'monkhood', titleEn: 'Monkhood Leave', titleTh: 'ลาไปประกอบพิธีทางศาสนา', used: '-', total: '-' },
        { key: 'other', titleEn: 'Other leave', titleTh: 'อื่นๆ', used: '-', total: '-' },
      ];
      return items.map(item => ({
        ...item,
        isFull: typeof item.used === 'number' && typeof item.total === 'number' && item.used >= item.total && item.total > 0
      }));
    },
  },
  watch: {
    "formLeave.absence_amount"(val) {
      if (val >= 0 && typeof val == "number" && val % 0.5 == 0) {
        this.formLeave.absence_amount = val;
      } else {
        this.formLeave.absence_amount = null;
        this.remarktext = "";
      }
    },
    "formLeave.absence_type"(val) {
      this.formLeave.start_date = "";
      this.formLeave.end_date = "";
      this.formLeave.absence_amount = 0;
      this.fileList = [];
      this.uploading = false;
      this.errorFile = "";
      this.formLeave.file_backup = null;
      this.formLeave.remark = null;
      if (!['casual_a', 'casual_b'].includes(val)) {
        this.blockForCasA = false
        this.blockForCasB = false
      } else {
        if (['casual_a'].includes(val)) {
          this.blockForCasA = true
          this.blockForCasB = false
        } else {
          this.blockForCasA = false
          this.blockForCasB = true
        }
      }
    },
    dateVal: {
      handler(val) {
        this.formLeave.absence_amount = 0;
        if (val.start_date === "" || val.start_date === null) {
          this.formLeave.end_date = "";
          this.holidayList = [];
        }
        if (
          val.start_date !== "" &&
          val.start_date !== null &&
          val.end_date !== "" &&
          val.end_date !== null
        ) {
          this.setCalTotalDate(val.start_date, val.end_date);
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.stBudgetYear()
    this.getDaySetting();
    this.getAllRequest();
    this.fetchLeaveData();
  },
  methods: {
    async getAllRequest() {
      await this.loadRequestHistory('/hri/leave_of_absence/', { start: 'timestart', end: 'timeend' });
    },
    async getDaySetting() {
      this.dataDayNotLeave = [];
      let nextY = this.moment().add(1, "year").format("YYYY");
      let s = this.moment(`${Number.parseInt(this.moment().format("YYYY")) - 1}-10-01`).format(
        "YYYY-MM-DD"
      );
      let e = this.moment(`${nextY}-09-30`).format("YYYY-MM-DD");
      const data = await this.fetchCalendarData(s, e);
      if (data) {
        for (let h = 0; h < data.length; h++) {
          const listD = data[h];
          if (["holiday"].includes(listD.calendar_type)) {
            this.dataDayNotLeave.push(listD.extra_date);
          }
        }
      }
    },
    handleStartOpenChange(open) { },
    handleEndOpenChange(open) {
      this.endOpen = open;
    },
    async fetchLeaveData() {
      try {
        this.loadingQuota = true;
        const resYear = await this.$http.get('/hri/leave_of_absence/view_year/');
        if (resYear.status === 200 && resYear.data.length > 0) {
          const years = resYear.data.map((item) => item.year).sort((a, b) => b - a);
          const latestYear = years[0];

          if (latestYear !== this.currentFiscalYear) {
            this.availableYears = [latestYear, this.currentFiscalYear].sort((a, b) => a - b);
            this.currentYear = this.currentFiscalYear;
          } else {
            this.availableYears = [latestYear];
            this.currentYear = latestYear;
          }
          console.log(this.currentYear)

          await this.fetchQuotaByYear();
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching leave data:', error);
      } finally {
        this.loadingQuota = false;
      }
    },
    async fetchQuotaByYear() {
      try {
        this.loadingQuota = true;
        this.formLeave.absence_type = null;
        this.casualQuota = 0;
        this.vacationQuota = 0;
        this.leaveSummary = { vacation: 0, sick: 0, medical: 0, extra: 0, casual: 0 };
        const targetYear = this.currentYear;
        const [resCasual, resSummary, resVacation] = await Promise.all([
          this.$http.get(`/hri/vacation_quota/casual/?year=${targetYear}`),
          this.$http.get(`/hri/leave_of_absence/summary_absence/?year=${targetYear}`),
          this.$http.get(`/hri/vacation_quota/?year=${targetYear}`),
        ]);

        if (resCasual.status === 200) {
          this.casualQuota = resCasual.data.casual_quota;
        }
        if (resSummary.status === 200) {
          this.leaveSummary = resSummary.data;
        }
        if (resVacation.status === 200 && resVacation.data.length > 0) {
          this.vacationQuota = resVacation.data[0].quota;
        }
      } catch (error) {
        console.error('Error fetching quota by year:', error);
      } finally {
        this.loadingQuota = false;
      }
    },
    addBusinessDays(date, daysToAdd) {
      let currentDate = this.moment(date);
      let addedDays = 0;

      while (addedDays < daysToAdd) {
        currentDate.add(1, 'days'); // เพิ่มวันทีละ 1
        if (currentDate.isoWeekday() < 6) { // เช็กว่าไม่ใช่เสาร์(6) อาทิตย์(7)
          addedDays++;
        }
      }

      return currentDate.format('YYYY-MM-DD');
    },
    isWeekend(date) {
      const d = this.moment(date).format("dddd");
      return d === "Saturday" || d === "Sunday";
    },

    isDateInBudget(date) {
      const year = Number.parseInt(this.moment(date).format("YYYY"));
      const yearMonth = this.moment(date).format("YYYY-MM");
      return this.stYear.includes(year) && this.stMonthBud.includes(yearMonth);
    },

    checkCasualBlocking(dateStr) {
      const today = this.moment().format('YYYY-MM-DD');

      if (this.blockForCasA) {
        // Normal Casual Leave
        const blockValue = this.addBusinessDays(today, 3);
        if (dateStr < today) return true;
        return dateStr < blockValue;
      }

      if (this.blockForCasB) {
        // Emergency Casual Leave
        return dateStr > today;
      }

      return false;
    },
    disabledStartDate(date) {
      this.holidayList = [];
      if (!date) return true;
      if (this.isWeekend(date)) return true;

      // Ensure moment object for date properties access if needed, but here we use format
      if (!this.isDateInBudget(date._d || date)) return true;

      const dateStr = this.moment(date).format("YYYY-MM-DD");
      if (this.dataDayNotLeave.includes(dateStr)) return true;

      if (this.blockForCasA || this.blockForCasB) {
        return this.checkCasualBlocking(dateStr);
      }

      return false;
    },
    disabledEndDate(endValue) {
      if (!endValue) return false;

      const startValue = this.formLeave.start_date;
      if (!startValue) return false;

      const endDateStr = this.moment(endValue).format("YYYY-MM-DD");
      const startDateStr = this.moment(startValue).format("YYYY-MM-DD");

      // Side effect: Track selected weekend as holiday for calculation
      if (this.isWeekend(endValue)) {
        if (this.holidayList.indexOf(endDateStr) < 0) {
          this.holidayList.push(endDateStr);
        }
        return true;
      }

      if (this.dataDayNotLeave.includes(endDateStr)) return true;

      // Casual blocking for end date
      if (this.blockForCasA) {
        return endDateStr < startDateStr;
      }
      if (this.blockForCasB) {
        const today = this.moment().format("YYYY-MM-DD");
        if (endDateStr <= today) {
          return endDateStr < startDateStr;
        } else {
          return true;
        }
      }

      return endDateStr < startDateStr;
    },
    calculateTotalDays(start, end) {
      const startDay = this.moment(start).startOf("day");
      const endDay = this.moment(end).startOf("day");
      if (endDay.isBefore(startDay)) return 0;

      // ประเภทที่นับวันต่อเนื่อง (รวมเสาร์-อาทิตย์และวันหยุด)
      if (["maternity", "monkhood", "long_term_medical"].includes(this.formLeave.absence_type)) {
        return endDay.diff(startDay, "days") + 1;
      }

      // ไม่นับเสาร์-อาทิตย์ และวันหยุดจาก getDaySetting (dataDayNotLeave)
      const holidaySet = new Set(this.dataDayNotLeave);
      let total = 0;
      const cursor = startDay.clone();
      while (cursor.isSameOrBefore(endDay, "day")) {
        const isWeekend = cursor.isoWeekday() >= 6;
        const isHoliday = holidaySet.has(cursor.format("YYYY-MM-DD"));
        if (!isWeekend && !isHoliday) total++;
        cursor.add(1, "day");
      }
      return total;
    },
    setCalTotalDate(a, b) {
      this.formLeave.absence_amount = this.calculateTotalDays(a, b);
    },
    handleRemove(file) {
      this.handleGenericRemove(file, 'fileList', 'file_backup', 'formLeave');
    },
    beforeUpload(file) {
      this.errorFile = "";
      if (this.isValidFile(file)) {
        this.formLeave.file_backup = file;
        this.fileList = [...this.fileList, file];
      }
      return false;
    },
    handleCheifRemove(file) {
      this.removeFileFromList(file, 'fileListCheif');
    },
    beforeCheifUpload(file) {
      this.errorFile = "";
      if (this.isValidFile(file)) {
        this.formLeave.fileCheif_backup = file;
        this.fileListCheif = [...this.fileListCheif, file];
      }
      return false;
    },
    gotoMainType() {
      if (this.$store.state.role.RulesUser.username.split('.').length === 2) {
        this.$router
          .push({
            path: "/hri/request",
          })
          .catch((err) => { });
      } else {
        this.$router
          .push({
            path: "/hri/",
          })
          .catch((err) => { });
      }
    },
    clearForm() {
      this.dialogConfirm = false;
      this.loading = false;
      this.formLeave = Object.assign({}, form);
      this.remarktext = "a.m.";
      this.boxLeaveError = [];
    },
    createLeaveRequestData() {
      const sendData = new FormData();
      Object.entries(this.formLeave).forEach(([key, value]) => {
        if (key === "fileCheif_backup") return;

        if (["start_date", "end_date"].includes(key)) {
          sendData.append(key, this.moment(value).format("YYYY-MM-DD"));
        } else if (key === 'absence_type') {
          sendData.append(key, ['casual_a', 'casual_b'].includes(`${value}`) ? 'casual' : value);
        } else if (key === "detail") {
          let detailVal = `${this.remarktext}::${value}`;
          if (['casual_a', 'casual_b'].includes(`${this.formLeave.absence_type}`)) {
            const typeText = ['casual_a'].includes(`${this.formLeave.absence_type}`) ? 'ลากิจแบบทั่วไป' : 'ลากิจแบบฉุกเฉิน';
            detailVal += `_:::_( ${typeText} )`;
          }
          sendData.append(key, detailVal);
        } else {
          sendData.append(key, value ?? '');
        }
      });

      if (this.$store.state.role.RulesUser.permissions.indexOf(`IC-HRI:chief`) >= 0) {
        sendData.append("chief_backup", this.formLeave.fileCheif_backup);
      }
      return sendData;
    },
    async submitRequestLeave() {
      this.loading = true;
      this.boxLeaveError = [];
      const sendData = this.createLeaveRequestData();
      try {
        const response = await this.$http.post(
          "/hri/leave_of_absence/",
          sendData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (response.status === 201) {
          this.clearForm();
          this.$router
            .push({
              path: "/hri/",
            })
            .catch((err) => { });
        } else {

          const err = new Error('API Error');
          err.response = response;
          throw err;
        }
      } catch (error) {
        this.loading = false;
        this.boxLeaveError.push(error.response.data);
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [
              h("strong", { class: "" }, `Error ${error.response.status}`),
            ]);
          },
          description: `Problem issue connect api : /hri/leave_of_absence/`,
        });
      }
    },
  },
};
</script>

<style scoped>
.f-14 {
  font-size: 14px;
}

.spin-content {
  border: 1px solid #91d5ff;
  background-color: #e6f7ff;
  padding: 30px;
}

.form-sub-title {
  font-size: 12px;
  margin-top: 5px;
  margin-bottom: 0px;
}

.w-full {
  width: 100%;
}

.submit-btn {
  padding: 5px;
  font-size: 16px;
  height: auto;
}

.form-container {
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 24px;
  height: 100%;
  background: #ffffff;
}

.h-full {
  height: 100%;
}

@media (max-width: 576px) {
  .submit-btn {
    width: 100%;
    margin-top: 10px;
  }
}

/* Quota Cards Styles */
.quota-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
}

.quota-card-wrapper {
  flex: 0 0 calc(16.666% - 12px);
  min-width: 120px;
  margin-bottom: 8px;
}

.quota-card-inner {
  position: relative;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 12px 6px;
  text-align: center;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: all 0.3s ease;
}

.quota-card-inner:hover {
  border-color: #4285F4;
  box-shadow: 0 4px 12px rgba(66, 133, 244, 0.1);
}

.quota-card-selected {
  border-color: #4285F4 !important;
  background-color: #f0f7ff !important;
  box-shadow: 0 4px 12px rgba(66, 133, 244, 0.15) !important;
}

.quota-card-selected::after {
  content: '✓';
  position: absolute;
  top: 4px;
  right: 8px;
  color: #4285F4;
  font-weight: 800;
  font-size: 14px;
}

.quota-card-disabled {
  opacity: 0.6;
  cursor: not-allowed !important;
  background-color: #f5f5f5 !important;
  border-style: dashed !important;
}

.quota-full-badge {
  font-size: 9px;
  color: #ff4d4f;
  background: #fff1f0;
  border: 1px solid #ffa39e;
  border-radius: 4px;
  padding: 0 4px;
  margin-top: 4px;
  display: inline-block;
  font-weight: 700;
}

.urgent-label {
  position: absolute;
  top: 5px;
  left: 0;
  right: 0;
  font-size: 10px;
  color: #ff4d4f;
  font-weight: 700;
}

.quota-title-en {
  font-size: 13px;
  font-weight: 800;
  color: #1a1a2e;
  line-height: 1.2;
}

.quota-title-th {
  font-size: 10px;
  color: #595959;
  margin-top: 2px;
}

.quota-stats {
  margin-top: 8px;
  font-size: 16px;
  font-weight: 800;
}

.quota-used {
  color: #1a1a2e;
}

.quota-sep {
  color: #1a1a2e;
  margin: 0 4px;
}

.quota-total {
  color: #ff4d4f;
}

@media (max-width: 1200px) {
  .quota-card-wrapper {
    flex: 0 0 calc(25% - 12px);
  }
}

@media (max-width: 991px) {
  .quota-card-wrapper {
    flex: 0 0 calc(33.333% - 12px);
  }
}

@media (max-width: 576px) {
  .quota-card-wrapper {
    flex: 0 0 calc(50% - 12px);
  }
}
</style>